import { render, staticRenderFns } from "./QuotePricesV2.vue?vue&type=template&id=26203874&scoped=true&"
import script from "./QuotePricesV2.vue?vue&type=script&lang=js&"
export * from "./QuotePricesV2.vue?vue&type=script&lang=js&"
import style0 from "./QuotePricesV2.vue?vue&type=style&index=0&id=26203874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26203874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
